import React from 'react';
import styled from 'styled-components';
import {HeaderTitle} from '../../../shared-components/custom-features/app-element/Title';
import {Btn} from '../../elements/button/btn-type/Btn';
import {Icon} from '../../elements/Icon/Icon';

/**
 * @param {object} param0
 *
 * @param {string} [param0.title]
 * This is used to be displayed a title to the aside section.
 *
 * @param {object} [param0.button]
 * An optional action button to be displayed alongside the  aside section title. This can be useful when the Aside section has edit and view mode features or a delete feature.
 *
 * @param {'edit' | 'delete' | 'add' | 'clear'} param0.button.icon
 * The name of the icon to be displayed on the action button.
 *
 * @param {React.MouseEventHandler<HTMLButtonElement>} param0.button.onClick
 * The function to be called when the action button is clicked.
 *
 * @example
 * ```js
 * // === How to the edit feature with ActionHeader === //
 * <Aside.Section>
 *      <Aside.ActionHeader
 *          title="Bestelling"
 *          button={isEditMode ? null : {icon: 'edit', onClick: startEdit}}
 *      />
 *      {!isEditMode && <div>View mode</div>}
 *      {isEditMode && <div>Edit mode</div>}
 * </Aside.Section>
 * ```
 */
export const AsideActionHeader = ({title, button}) => {
    return (
        <AsideActionHeaderWrapper>
            <HeaderTitle>{title}</HeaderTitle>
            {button && (
                <Btn onClick={button.onClick} color="primary" subtle link>
                    <Icon name={button.icon} />
                </Btn>
            )}
        </AsideActionHeaderWrapper>
    );
};

export const AsideActionHeaderWrapper = styled.div`
    display: flex;
    min-height: unset;
    justify-content: space-between;
    gap: 4px;
    align-items: center;
    margin-bottom: var(--space-xsm);
    h1 {
        margin: 0;
    }
`;
